export default __webpack_public_path__ + "static/background_transparent_splash-b775367e65b2892ce314c4a910221b95.png";